// The registry is data, not an enum: adding a package does not change account or game logic.
export function createCatalog(manifest, packages) {
  if (manifest.version !== 1) throw new Error('Unsupported presentation manifest');
  const ids = manifest.settings.map(item => item.id);
  if (new Set(ids).size !== ids.length) throw new Error('Duplicate presentation ID');
  const available = manifest.settings.filter(item => item.enabled && packages[item.id])
    .sort((a, b) => a.order - b.order);
  if (!available.some(item => item.id === manifest.fallback)) throw new Error('Missing fallback presentation');
  // Incomplete future packages render with neutral media; validation reports the omissions.
  const resolved = Object.fromEntries(available.map(item => {
    const neutral = packages[manifest.fallback];
    const current = packages[item.id];
    const pack = { ...neutral, ...current, messages: { ...neutral.messages, ...current.messages } };
    for (const method of ['icon', 'scene', 'guildImage', 'stageImage', 'flyer']) {
      if (typeof neutral[method] === 'function') {
        pack[method] = (...args) => {
          if (typeof current[method] === 'function') {
            const res = current[method](...args);
            if (res !== undefined) return res;
          }
          return neutral[method](...args);
        };
      }
    }
    return [item.id, pack];
  }));
  return {
    available,
    fallback: manifest.fallback,
    accepts: id => available.some(item => item.id === id),
    resolve: id => available.some(item => item.id === id) ? id : manifest.fallback,
    package: id => resolved[available.some(item => item.id === id) ? id : manifest.fallback],
  };
}

export function mergeResources(base, overlay) {
  const result = { ...base };
  for (const [key, value] of Object.entries(overlay || {})) {
    result[key] = value && typeof value === 'object' && !Array.isArray(value)
      ? mergeResources(base?.[key] || {}, value) : value;
  }
  return result;
}
